import * as React from "react";
import LiquorItem from "../product-item";
import Loader from "../loader";
import CONSTS from "../../consts";
const InfiniteScroll = require('react-infinite-scroller');
export default class SearchResults extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        let items = this.props.products.map((product, index) => {
            return React.createElement(LiquorItem, { key: index, country: product.Country, category: product.ConsumerCategory, liqType: product.ConsumerType, showWhereToBuy: true, hideShoppingControls: true, city: product.Region, title: product.Name, imgPath: `${CONSTS.STORAGEURL}/${CONSTS.PRODUCTCONTAINER}/${product.SKU ? product.SKU.trim() : "NotAvail"}.jpg`, sponsored: product.SponsoredSKU, id: product.DisplaySKU, madeInAlberta: product.MadeInAlberta, singlesPerUnit: product.SinglesPerUnit, size: product.Size });
        });
        let loader = React.createElement("div", { className: "loader" },
            React.createElement(Loader, null));
        return (React.createElement("div", { className: "search-results" },
            React.createElement("div", { className: "search-items" },
                React.createElement(InfiniteScroll, { pageStart: 0, initialLoad: true, loadMore: this.props.getProducts, hasMore: this.props.count > 0 && this.props.products.length < this.props.count, loader: loader }, items))));
    }
}
;
//# sourceMappingURL=search-results.js.map